import { render } from "./mian-layout-editor.vue?vue&type=template&id=d939633a&scoped=true"
import script from "./mian-layout-editor.vue?vue&type=script&lang=js"
export * from "./mian-layout-editor.vue?vue&type=script&lang=js"

import "./mian-layout-editor.vue?vue&type=style&index=0&id=d939633a&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d939633a"]])

export default __exports__